import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let { iconChessPieceSolid } = await import('@bolt/elements-icon');

export class BoltLayout {
  constructor(el) {
    if (!el) return;
    this.el = el;
    this.init();
  }

  init() {
    //only call the observer if there is a layout with the mask attribute
    if (this.el.hasAttribute('mask')) {
      // leaving this with a couple extra variables so the groundwork
      // is layed for adding conditionals for configuring icons later.
      let targetIcon = iconChessPieceSolid();

      // this escapes the icon markup for use in the mask-image style url property.
      // im not sure if any other symbols needs to be escaped but this is getting the job done so far.
      this.escapedIcon = targetIcon
        .replaceAll('#', '%23')
        .replaceAll('"', '\\"');

      // set the mask-image with the necessary data and the above icon
      this.setMaskVisibility(true);

      // handle the observer that animates the icon mask.
      this.handleMaskObserver();
    }
  }

  handleMaskObserver() {
    this.maskState = { size: 10 };
    this.maskTween = null;
    this.itemsTween = null;
    this.buttonTween = null;
    this.setVideoMaskSize(this.el, this.maskState.size);

    ScrollTrigger.create({
      trigger: this.el,
      start: 'bottom bottom-=50px',
      end: 'top top+=50px',
      scrub: false,
      onEnter: () => this.scrollEnter(),
      onEnterBack: () => this.scrollEnter(),
      onLeave: () => this.scrollLeave(),
      onLeaveBack: () => this.scrollLeave(),
    });
  }

  setVideoMaskSize(el, percent) {
    el.style.maskSize = `${percent}%`;
    el.style.webkitMaskSize = `${percent}%`;
  }

  scrollEnter() {
    this.killAllTweens();

    this.maskTween = gsap.to(this.maskState, {
      size: window.innerWidth,
      duration: window.innerWidth < 500 ? 0.35 : 1,
      ease: 'power2.in',
      onUpdate: () => this.setVideoMaskSize(this.el, this.maskState.size),
      onComplete: () => this.setMaskVisibility(false),
    });

    this.itemsTween = gsap.to(this.el.querySelectorAll('bolt-layout-item'), {
      opacity: 1,
      y: '0%',
      duration: window.innerWidth < 500 ? 0.25 : 0.5,
      ease: 'power2.out',
      stagger: 0.1,
      delay: 0.4,
    });

    this.buttonTween = gsap.to(
      this.el.querySelector('.js-bolt-background-video-toggle'),
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: 'power1.in',
        delay: 1,
      },
    );
  }

  scrollLeave() {
    this.killAllTweens();

    this.maskTween = gsap.to(this.maskState, {
      size: 10,
      duration: window.innerWidth < 500 ? 0.25 : 0.5,
      delay: 0.4,
      ease: 'power.out',
      onUpdate: () => this.setVideoMaskSize(this.el, this.maskState.size),
      onStart: () => this.setMaskVisibility(true),
    });

    this.itemsTween = gsap.to(this.el.querySelectorAll('bolt-layout-item'), {
      opacity: 0,
      y: '-20%',
      duration: 0.4,
      ease: 'power1.in',
    });

    this.buttonTween = gsap.to(
      this.el.querySelector('.js-bolt-background-video-toggle'),
      {
        opacity: 0,
        y: '-20%',
        duration: 0.4,
        ease: 'power1.in',
      },
    );
  }

  killAllTweens() {
    if (this.maskTween) this.maskTween.kill();
    if (this.itemsTween) this.itemsTween.kill();
    if (this.buttonTween) this.buttonTween.kill();
  }

  setMaskVisibility(visibilty) {
    if (visibilty) {
      this.el.style.maskImage = `url("data:image/svg+xml;utf8,${this.escapedIcon}")`;
      this.el.style.webkitMaskImage = `url("data:image/svg+xml;utf8,${this.escapedIcon}")`;
    } else {
      this.el.style.maskImage = 'none';
      this.el.style.webkitMaskImage = 'none';
    }
  }
}
